import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { userActivityInProcess, users } from "redux-store/user/user.selectors";
import { getAllUsers } from "redux-store/user/user.slice";
import { AppDispatch } from "redux-store/store";
import Loader from "components/loader/Loader";
import ActiveUsersRow from "./ActiveUserRow";
import { ToastContainer } from "react-toastify";


const ActiveUsers = () => {
  const dispatch = useDispatch<AppDispatch>();
  const usersData = useSelector(users);
  
  const loading = useSelector(userActivityInProcess);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);

  
  return (
    <>
      <ToastContainer/>
      <div className="tw-w-[90%] tw-relative tw-mx-auto tw-bg-[#FFFFFF] tw-shadow-3xl tw-rounded-xl  tw-py-7">
        <div className="tw-w-[90%] tw-mx-auto ">
          {/* 1st item */}
          <div className="tw-flex tw-items-center tw-justify-between tw-mb-5">
            <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-items-center">
              User Name
            </div>
            <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold tw-flex tw-gap-2 tw-items-center">
              Email
            </div>

            <div className="tw-flex-1 tw-text-xl tw-text-[#29223E] tw-font-bold"></div>
          </div>
          {/* 2nd item */}
          {usersData && 
            usersData.length > 0 &&
            usersData.map((user) => (
              <div key={user._id}>
                <ActiveUsersRow user={user} />
              </div>
            ))}

          {loading && <Loader />}
          {!loading && usersData?.length === 0 && "No Result Found"}
        </div>
      </div>
    </>
  );
};

export default ActiveUsers;
